import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface StatutCapteur {
  id: number;
  nom: string;
}

@Injectable({ providedIn: 'root' })
export class StatutCapteursService {
  private readonly baseUrl = `${environment.apiBaseUrl}/api/statut_capteurs`;

  constructor(private http: HttpClient) {}

  list(): Observable<StatutCapteur[]> {
    return this.http.get<StatutCapteur[]>(this.baseUrl);
  }
}
